import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Header } from '@/components/layout/Header';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const ForgotPasswordPage = () => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess('');
    setError('');
    setLoading(true);
    try {
      await resetPassword(email);
      setSuccess('Pokyny k obnovení hesla byly odeslány na váš email.');
    } catch (err) {
      setError('Nepodařilo se odeslat email pro obnovení hesla.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center p-4 bg-gray-50">
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-8 max-w-md w-full mx-auto">
          <h1 className="text-2xl font-bold mb-4">Zapomenuté heslo</h1>
          <p className="mb-4 text-gray-600">Zadejte svůj email a my vám pošleme odkaz pro obnovení hesla.</p>
          <Input
            type="email"
            placeholder="vas@email.cz"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="mb-4"
            disabled={loading}
          />
          <Button type="submit" className="w-full mb-2" disabled={loading}>
            {loading ? 'Odesílání...' : 'Obnovit heslo'}
          </Button>
          {success && <div className="text-green-600 text-sm mt-2">{success}</div>}
          {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
        </form>
      </main>
    </div>
  );
};

export default ForgotPasswordPage; 